import { Customization, Input } from '../types/Customization'
import { fabric } from 'fabric'
import { StoredTemplate } from '../types/Individualization'
import { loadClipPath } from './loadClipPath'

export const buildClipPath = (spotId: number, template: StoredTemplate) => {
    const spot = template.spots.find((spot) => spot.id === spotId)
    if (!spot) {
        return undefined
    }

    return loadClipPath(spot)
}
const addTextInput = (
    input: Input,
    canvas: fabric.Canvas,
    template: StoredTemplate
) => {
    const text = new fabric.Text(input.value, {
        angle: input.angle || 0,
        flipX: input.flipX || false,
        flipY: input.flipY || false,
        fontFamily: input.font_family,
        fontSize: parseFloat(input.font_size),
        height: input.height,
        left: input.left,
        scaleX: input.scaleX || 1,
        scaleY: input.scaleY || 1,
        textAlign: input.text_align || 'ltr',
        fill: input.text_color,
        top: input.top,
        originX: 'center',
        originY: 'center',
        centeredScaling: true,
        width: input.width,
        data: {
            id: input.id,
            spot_id: input.spot_id,
            type: 'user_input',
        },
        selectable: false,
        hoverCursor: 'default',
        hasControls: false,
        absolutePositioned: true,
    })

    text.set('clipPath', buildClipPath(input.spot_id, template))

    canvas.add(text)
    canvas._objects = canvas._objects.sort((a, b) => {
        const aIndex = a.data.id || 0
        const bIndex = b.data.id || 0
        return aIndex - bIndex
    })
}

const addImageInput = (
    input: Input,
    canvas: fabric.Canvas,
    template: StoredTemplate
): Promise<void> => {
    return new Promise((resolve) => {
        fabric.Image.fromURL(input.value, (fabricImage: fabric.Image) => {
            const spot = template.spots.find((spot) => spot.id == input.spot_id)
            if (spot?.grayscale) {
                fabricImage.filters = [
                    ...(fabricImage.filters ?? []),
                    new fabric.Image.filters.Grayscale(),
                ]
                fabricImage.applyFilters()
            }

            const img = fabricImage.set({
                angle: input.angle || 0,
                flipX: input.flipX || false,
                flipY: input.flipY || false,
                left: input.left,
                top: input.top,
                scaleX: input.scaleX || 1,
                scaleY: input.scaleY || 1,
                originX: 'center',
                originY: 'center',
                centeredScaling: true,
                data: {
                    id: input.id,
                    spot_id: input.spot_id,
                    type: 'user_input',
                },
                selectable: false,
                hoverCursor: 'default',
                hasControls: false,
                width: input.width,
                height: input.height,
                absolutePositioned: true,
            })

            img.set('clipPath', buildClipPath(input.spot_id, template))
            canvas.add(img)
            canvas._objects = canvas._objects.sort((a, b) => {
                const aIndex = a.data.id || 0
                const bIndex = b.data.id || 0
                return aIndex - bIndex
            })
            resolve()
        })
    })
}

export const loadInputs = async (
    customization: Customization,
    template: StoredTemplate,
    canvas: fabric.Canvas,
    spot_filter_id: number | undefined = undefined
) => {
    const inputs = customization.inputs.filter((input) => {
        return template.spots.some((spot) => spot.id === input.spot_id)
    })

    let count = 0

    for (const input of inputs) {
        if (!spot_filter_id || input.spot_id === spot_filter_id) {
            if (input.type === 'text' && input.value.trim() !== '') {
                addTextInput(input, canvas, template)
                count++
            } else if (input.type === 'image' && input.value.trim() !== '') {
                await addImageInput(input, canvas, template)
                count++
            } else {
                console.warn('Unsupported input type:', input.type)
            }
        }
    }

    canvas.renderAll()

    return count
}
